import { render, staticRenderFns } from "./TierTable.vue?vue&type=template&id=0fa311ce&scoped=true"
import script from "./TierTable.vue?vue&type=script&lang=js"
export * from "./TierTable.vue?vue&type=script&lang=js"
import style0 from "./TierTable.vue?vue&type=style&index=0&id=0fa311ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa311ce",
  null
  
)

export default component.exports